export default __webpack_public_path__ + "static/media/pic1.02450122.jpg";